import {css} from '../theme/css'
import {cssTheme} from '../v2/theme'
import {PaperFloat} from './types'

export const item = css`
  box-shadow: none;
  overflow: initial;
`
export const header = css`
  border-start-end-radius: 0;
  border-start-start-radius: 0;
`
export const footer = css`
  border-end-end-radius: 0;
  border-end-start-radius: 0;
`
export const floatRoot = css`
  position: fixed;
  inset-inline-start: 0;
  inset-inline-end: 0;
  box-shadow: ${cssTheme.shadows.topNormal};
`
export const float: Record<PaperFloat, string> = {
  bottom: css`
    inset-block-end: 0;
    border-end-end-radius: 0;
    border-end-start-radius: 0;
  `,
  top: css`
    inset-block-start: 0;
    border-start-end-radius: 0;
    border-start-start-radius: 0;
  `,
}
